export default __webpack_public_path__ + "static/media/header-visu8.0213973f.jpg";